import {
  AlertDialog,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/AlertDialog";
import { Button } from "@/ui/Button";
import Link from "next/link";
import { useTranslation } from "react-i18next";

const UseMobileToRegisterAlert = ({
  open = true,
  setOpen = () => {},
  isClosable = false,
}) => {
  const { t } = useTranslation("register");

  return (
    <AlertDialog open={open} onOpenChange={setOpen}>
      <AlertDialogContent className="*:!text-center">
        <AlertDialogHeader>
          <AlertDialogTitle>
            {t("phone_verification_required")}
          </AlertDialogTitle>
          <AlertDialogDescription className="leading-relaxed">
            {t("registration_restriction_description")}
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter className="sm:flex-col sm:space-x-0">
          <Link href="/" passHref>
            <Button>{t("home_page_button")}</Button>
          </Link>
          {isClosable ? (
            <Button onClick={() => setOpen(false)} variant="secondary">
              {t("close_button")}
            </Button>
          ) : (
            <Link href="/login" passHref>
              <Button variant="secondary">{t("login_button")}</Button>
            </Link>
          )}
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
};

export default UseMobileToRegisterAlert;
